import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { tablet } from "../../../../media";

const glowA = "0px -2px 12px 0px #5E84ED73";
const glowB = "0px -4px 18px 0px #5E84ED99";
const glowC = "0px -2px 14px 0px #5E84ED55";

export const TypeOuter = styled(motion.div)`
    width: 100%;
    padding: 0 16px 32px;
    box-sizing: border-box;

    ${tablet`
        max-width: 720px;
        margin: 0 auto;
    `}
`;

export const SheetDrag = styled(motion.div)`
    width: 100%;
`;

export const TypeContainer = styled.div`
    width: 100%;
    min-height: 160px;

    border-radius: 12px;
    border-top: 1px solid #2b2d33;
    background: #23252a;

    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    box-shadow: ${glowA};
    box-sizing: border-box;

    animation: typeGlow 3s ease-in-out infinite;

    @keyframes typeGlow {
        0% {
            box-shadow: ${glowA};
            transform: translateZ(0);
        }
        45% {
            box-shadow: ${glowB};
        }
        100% {
            box-shadow: ${glowC};
        }
    }
`;

export const DragHandle = styled.div`
    width: 36px;
    height: 4px;
    background: #2b2d33;
    border-radius: 999px;
    margin: 0 auto;

    /* important so dragging works well on mobile */
    touch-action: none;
    cursor: grab;

    &:active {
        cursor: grabbing;
    }
`;

export const TypeTextarea = styled.textarea`
    -webkit-appearance: none;
    appearance: none;
    border: none;
    outline: none;
    background: transparent;

    width: 100%;

    /* ✅ grows naturally up to 200px */
    height: auto;
    min-height: 68px;
    max-height: 200px;

    overflow-y: hidden; /* JS toggles to auto if needed */
    resize: none;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 8px;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0px;
    color: #e9ecf5;

    &::placeholder {
        font-size: 14px;
        line-height: 140%;
        letter-spacing: 0px;
        color: #b7bdcb;
        opacity: 1;
    }

    scrollbar-width: thin;
    scrollbar-color: rgba(183, 189, 203, 0.35) transparent;

    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(183, 189, 203, 0.28);
        border-radius: 999px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: rgba(183, 189, 203, 0.42);
    }
`;

export const BottomActions = styled.div`
    margin-top: auto;

    display: flex;
    align-items: flex-end;
    justify-content: flex-end;

    gap: 24px;
    padding-right: 8px;
`;

export const IconBtn = styled.button`
    width: 44px;
    height: 44px;

    border: none;
    background: transparent;
    padding: 0;
    margin: 0;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    transition: opacity 80ms ease, transform 80ms ease;

    &:active {
        opacity: 0.65;
        transform: scale(0.88);
    }

    &:focus-visible {
        outline: 2px solid #b7bdcb;
        outline-offset: 2px;
        border-radius: 12px;
    }

    img {
        width: 44px;
        height: 44px;
        display: block;
        -webkit-user-select: none;
        user-select: none;
        -webkit-user-drag: none;
    }
`;

/* ── File attachment strip ── */

export const FileStrip = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 2px 0;

    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
`;

export const FileChip = styled.div`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    padding: 4px 8px;
    background: #1e1f22;
    border-radius: 10px;
    outline: 1px #2b2d33 solid;
    outline-offset: -1px;
    max-width: 200px;
`;

export const FileChipLabel = styled.span`
    color: rgba(233, 236, 245, 0.9);
    font-size: 13px;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        Segoe UI,
        Roboto,
        sans-serif;
    font-weight: 400;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 140px;
`;

export const FileChipRemove = styled.button`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    color: #7d8493;
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    border-radius: 999px;
    transition: color 80ms ease;

    &:active {
        color: #e9ecf5;
    }
`;
